// extracted by mini-css-extract-plugin
export default {"patientContent":"PatientContent_patientContent__lah3G"};